export const TRI_STATE_FILTER = {
  OCULTAR: "OCULTAR",
  TODOS: "TODOS",
  SOMENTE: "SOMENTE",
} as const;

export type TriStateFilter =
  (typeof TRI_STATE_FILTER)[keyof typeof TRI_STATE_FILTER];

export const ITEM_STATUS_FILTER = {
  TODAS: "TODAS",
  AGUARDANDO_APLICACAO: "AGUARDANDO_APLICACAO",
  EM_REMARCACAO: "EM_REMARCACAO",
  SEM_SITUACAO: "SEM_SITUACAO",
} as const;

export type ItemStatusFilter =
  (typeof ITEM_STATUS_FILTER)[keyof typeof ITEM_STATUS_FILTER];

